import React from 'react'

export default function DefaultLayout({children, className}) {
  return <div className={className}>
    {children}
  </div>
}
